var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"captchaComp",attrs:{"width":"240","height":"90"}})
}
var staticRenderFns = []

export { render, staticRenderFns }